/**
 * Environment Configuration
 *
 * Provides access to runtime environment variables injected by the container.
 * Get environment configuration from runtime injection
 */
const getEnvConfig = () => {
    return window?.process?.env || {};
};

// Export the configuration
export default getEnvConfig();
